import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=b30bb36a&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=b30bb36a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30bb36a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b30bb36a')) {
      api.createRecord('b30bb36a', component.options)
    } else {
      api.reload('b30bb36a', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=b30bb36a&scoped=true&", function () {
      api.rerender('b30bb36a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-268mzVIqTumMG/JS/teamMember.vue"
export default component.exports